const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 195 196",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.418312,0,0,0.614472,-56.7445,-69.9078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.651,
    y: 113.769,
    width: 464.556,
    height: 317.605,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.96067,0,0,6.78089,-53.407,-96.2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.23,54.38C59.23,57.05 57.8,59.39 55.67,60.68L37.27,74.86L37.19,74.92C35.95,75.87 34.4,76.44 32.72,76.44C28.66,76.44 25.37,73.15 25.37,69.09C25.37,66.41 26.81,64.06 28.95,62.78L39.86,54.4L28.45,45.68C26.58,44.35 25.37,42.16 25.37,39.69C25.37,35.63 28.66,32.34 32.72,32.34C34.24,32.34 35.65,32.8 36.82,33.59L37.57,34.16L55.68,48.1C57.8,49.36 59.23,51.7 59.23,54.38Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.8671,0,0,33.8671,31.2111,54.3752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(119,202,228)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "rgb(107,193,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "rgb(74,169,197)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(35,147,176)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpLogoIcon);
export default __webpack_public_path__ + "static/media/SP_logo_icon.70390b76a7fb66991eb8e329afd4a8ac.svg";
export { ForwardRef as ReactComponent };